import { MenuItem, TextField } from '@mui/material';
import React from 'react';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import { valueByName } from './form_utils';

export const ECSelectField = props => {
  const { name, label, options, form, fid: fidProp, fname: fnameProp, defaultValue, initial, ...rest } = props;
  const fname =
    fnameProp ||
    (it => {
      return it.name;
    });
  const fid =
    fidProp ||
    (it => {
      return it.id;
    });
  let dv = valueByName(initial, name);
  if (dv === null || dv === undefined) {
    dv = defaultValue;
  }
  if (dv === null || dv === undefined) {
    dv = '';
  }
  return (
    <Controller
      control={form.control}
      name={name}
      defaultValue={dv}
      render={({ field, fieldState }) => (
        <TextField
          {...field}
          label={label}
          select
          fullWidth
          margin='dense'
          variant='outlined'
          helperText={fieldState.error?.message}
          error={!!fieldState.error}
          {...rest}
        >
          {options.map(it => (
            <MenuItem key={fid(it)} value={fid(it)}>
              {fname(it)}
            </MenuItem>
          ))}
        </TextField>
      )}
    />
  );
};

ECSelectField.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,

  options: PropTypes.array,
  fname: PropTypes.func,
  fid: PropTypes.func,

  form: PropTypes.object,

  defaultValue: PropTypes.any,
  initial: PropTypes.object,
};
